
export const site = {
  name: process.env.REACT_APP_NAME,
  title: process.env.REACT_APP_TITLE,
  code: process.env.REACT_APP_CODE,
  version: process.env.REACT_APP_VERSION || 'v1.0',
  environment: process.env.REACT_APP_NODE_ENV || 'development',
};

export const routes = {
  baseAdminRoute: process.env.REACT_APP_ADMIN_ROUTES || '/backoffice',
};
